export const config = {
  title: 'Debra Bergeron | Premium Properties Real Estate',
  meta: {
    description:
      'As a proud Florida native, Debra Bergeron specializes in buying and selling properties throughout Central Florida, offering personalized service and expert guidance.',
    keywords: [
      'Real Estate',
      'Central Florida Properties',
      'Beachfront Homes',
      'Suburban Retreats',
      'Ranch Estates',
      'Property Buying',
      'Property Selling',
      'Premium Properties Real Estate',
      'Debra Bergeron',
      'Lake Mary FL Real Estate',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'Debra Bergeron',
    canonicalUrl: 'https://www.debbiebsells.com/',
  },
  sections: {
    header: {
      businessName: 'Debra Bergeron - Premium Properties Real Estate',
    },
    sectionB: {
      heroTitle: 'Find Your Perfect Piece of Paradise',
      heroSubtitle: 'Specializing in Central Florida Real Estate',
      learnAboutText: 'Explore Our Listings',
      phoneNumber: '4075085539',
      phoneLabel: '(407) 508-5539',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1481196113/photo/young-couple-viewing-property-for-sale-talking-with-professional-real-estate-agent-outside.jpg?s=612x612&w=0&k=20&c=-vKehNKZKv6EcFmhrguHftK3TIPF_wQBlhtoiu18TFE=',
      cardData: [
        {
          title: 'Personalized Service',
          description:
            'Providing tailored real estate solutions to meet your unique needs.',
        },
        {
          title: 'Expert Guidance',
          description:
            'Offering in-depth knowledge of Central Florida’s diverse property market.',
        },
        {
          title: 'Trust and Integrity',
          description:
            'Committed to transparent and honest communication throughout your real estate journey.',
        },
      ],
      description:
        'As a proud Florida native and experienced real estate professional, Debra Bergeron specializes in buying and selling properties throughout Central Florida, from beachfront homes to charming suburban retreats and expansive ranch estates.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore the comprehensive real estate services we offer to help you achieve your property goals.',
      cards: [
        {
          title: 'Property Buying Assistance',
          description:
            'Guiding you through the process of finding and purchasing your ideal home or investment property.',
          imageSrc: 'https://media.istockphoto.com/id/1322158065/photo/business-people-contract-agreement-was-signed-co-investment-business.jpg?s=612x612&w=0&k=20&c=QE_ydA8qCzFkzAuTmzoCcQNg6nyKEBULRnlzp7Xihtc=',
          imageAlt: 'Property Buying Assistance',
        },
        {
          title: 'Property Selling Services',
          description:
            'Providing expert advice and strategies to effectively market and sell your property.',
          imageSrc: 'https://media.istockphoto.com/id/932278678/photo/calculator-with-wooden-house-and-coins-stack-and-pen-on-wood-table-property-investment-and.jpg?s=612x612&w=0&k=20&c=oGGy2X0v7RolkEl83MdNXdwR0Uc3AyMmPFKEIlnYHqk=',
          imageAlt: 'Property Selling Services',
        },
        {
          title: 'Market Analysis',
          description:
            'Offering detailed insights into current market conditions to inform your real estate decisions.',
          imageSrc: 'https://media.istockphoto.com/id/1482730818/photo/group-of-confident-business-people-point-to-graphs-and-charts-to-analyze-market-data-balance.jpg?s=612x612&w=0&k=20&c=ESfR9iAcNwQghBTKI3e_E6QY1dEg0lAkTmH8KZkInBY=',
          imageAlt: 'Market Analysis',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Community Information',
        'Investment Property Consultation',
        'Relocation Assistance',
        'Home Staging Advice',
        'Mortgage Referral Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Debra Bergeron',
      aboutImage: {
        src: 'https://images.marketleader.com/MarketingImages/36/2404536_normal.jpg',
        alt: 'Debra Bergeron',
      },
      aboutText: [
        'As a proud Florida native, Debra brings a wealth of experience and passion to the real estate industry in Central Florida. Her background as a professional cowgirl has instilled a strong work ethic and a deep appreciation for the region’s diverse landscapes.',
        'Whether you’re searching for an investment, a spacious property, or a forever home, Debra provides personalized service and expert guidance every step of the way. Trust, integrity, and dedication are at the heart of her approach.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Premium Properties Real Estate Logo',
      businessName: 'Debra Bergeron | Real Estate',
      contact: {
        phone: '4075085539',
        phoneLabel: '(407) 508-5539',
        email: 'debrabergeron5539@gmail.com',
        website: 'https://www.debbiebsells.com/',
        address: '4227 West Lake Mary Boulevard, Lake Mary, FL 32746',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/profile.php?id=61565087815269&mibextid=wwXIfr&mibextid=wwXIfr',
        instagram: 'https://www.instagram.com/debbie_sells_homes/?igsh=MWFjNHp5aHJwMnE1Ng%3D%3D&utm_source=qr#',
        linkedin: 'https://www.linkedin.com/in/debra-bergeron-093697320/',
        twitter: 'https://x.com/DebbieSellsFla',
        youtube: null,
      },
    },
    sectionF: {
      address: '4227 West Lake Mary Boulevard, Lake Mary, FL 32746',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.123456789012!2d-81.3456789!3d28.7456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7654321abcdef%3A0x1234567890abcdef!2s4227%20W%20Lake%20Mary%20Blvd%2C%20Lake%20Mary%2C%20FL%2032746!5e0!3m2!1sen!2sus!4v1610000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
